import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2WarningDialog } from "../../../view/dialogs/Poker2WarningDialog";
import { Poker2Command } from "../Poker2Command";

export class LLPCommand extends Poker2Command {
    protected get cmdId(): string {
        return "llp";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                this.layoutManager.showDialog("Poker2WarningDialog",
                    new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_login_lostpassword"),
                        Poker2Model.languageData.getTextById("generic_change_password_copy_send")));
                break;
            case 21:
                this.layoutManager.showDialog("Poker2WarningDialog",
                    new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"),
                        Poker2Model.languageData.getTextById("generic_register_error_invalidemail")));
                break;
            default:
                return super.executeCommand(error, params);
        }
        return true;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
